var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExploreBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10318_145192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2059 12.6298C20.2059 16.9763 16.6823 20.4998 12.3358 20.4998C7.98935 20.4998 4.46582 16.9763 4.46582 12.6298C4.46582 8.2833 7.98935 4.75977 12.3358 4.75977C16.6823 4.75977 20.2059 8.2833 20.2059 12.6298Z",
    stroke: "#1E1E1E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.28539 12.9985L4.49982 14.4995L4.96448 15.1965C4.3171 15.9421 3.90238 16.5971 3.70109 17.1189C3.49299 17.6584 3.56594 17.9003 3.61601 17.9871C3.66608 18.0738 3.83911 18.2579 4.41039 18.3475C4.97057 18.4353 5.75892 18.4015 6.74708 18.2067C8.71318 17.8192 11.247 16.8392 13.8551 15.3334C16.4632 13.8276 18.5788 12.1233 19.8975 10.6143C20.5603 9.85596 20.9836 9.1901 21.1877 8.66107C21.3958 8.12157 21.3229 7.87965 21.2728 7.79293C21.2227 7.7062 21.0497 7.52206 20.4784 7.43253C19.9259 7.34595 19.1516 7.37757 18.1824 7.56531L16.6895 5.8591C17.0554 5.76163 17.4112 5.67879 17.7549 5.61103C18.8669 5.39183 19.9099 5.31903 20.7881 5.45665C21.6551 5.59253 22.5273 5.96578 23.0048 6.79293C23.4824 7.62007 23.3695 8.56201 23.0537 9.38083C22.7338 10.2101 22.1492 11.0771 21.4034 11.9304C19.905 13.6451 17.6011 15.4801 14.8551 17.0655C12.1091 18.6508 9.36801 19.7286 7.13389 20.169C6.02194 20.3882 4.97885 20.461 4.10072 20.3233C3.23368 20.1875 2.36152 19.8142 1.88396 18.9871C1.40641 18.1599 1.51925 17.218 1.83509 16.3992C2.15497 15.5699 2.73957 14.7029 3.48537 13.8495C3.73094 13.5686 3.99815 13.2843 4.28539 12.9985Z",
    fill: "#1E1E1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10318_145192"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreBlack);
export default __webpack_public_path__ + "static/media/explore_black.9f1ef24a04008802a61495b1361347c0.svg";
export { ForwardRef as ReactComponent };